
/* injects from baggage-loader */

export const TrunkIcons = {
    default: require('_images/stages/stage-three/trunk.png'),
    submerged: require('_images/stages/stage-three/trunk-submerged.png')
}

export const initFeedbackTexts = [
    'Minha nossa!<br> A <b>floresta</b> está <b>inundada</b>! Tudo isso foi causado pela constução de <b>barragens</b> que <b>impedem</b> o caminho do <b>rio</b>.',
    'Agora aqueles <b>macacos</b> não podem alcançar seu <b>alimento</b>. Vamos  ajudá-los a chegar até a <b>bananeira pulando</b> nos <b>troncos</b> que estão <b>boiando</b>.'
];

export const feedbackTexts = [
    'Você conseguiu <b>limpar</b> todo o rio e <b>separar o lixo</b>. Agora o rio está <b>limpo</b> e o filhote poderá <b>beber água</b>.',
    'Porém, ainda tenho alguns <b>desafios</b> para você! <br> Vamos lá?'
];


const helpImg = require('_images/stage-helps/macaco.png');

export const helpTpl = `
    <div class='container-fluid'>
        <div class='row'>        
            <div class='col-xs-7'>
                <img src='${helpImg}' class='img-responsive' />
            </div>
            <div class='col-xs-5 text-left'>
                <div class='container-fluid'>
                    <p class='subtitle'>Ajude os macacos a <b>chegarem até a bananeira</b> para se alimentar. Para isso, você deve ajudá-los a <b>pular troncos</b> que estão boiando no meio do rio. Observe que cada um dos macacos consegue pular uma <b>determinada quantidade</b> de troncos.</p>
                    <p class='subtitle'><b>Escolha</b> um dos macacos e <b>clique nos troncos</b> de acordo com a quantidade de pulos que cada um é capaz de dar. Faça isso até que os macacos consigam <b>chegar até a bananeira</b>.</p>
                    <p class='subtitle'>Vamos lá!</p>
                </div>
            </div>
        </div>
    </div>
`


export const level1SelectedMonkey1 = [
    'Você escolheu o <b>macaco filhote</b>. Este macaco só consegue pular de <b>2 em 2</b> troncos. <b>Clique</b> nos troncos que ele deverá pular para chegar até a <b>bananeira</b></p>'
];

export const level1SelectedMonkey2 = [
    'Você escolheu o <b>macaco adulto</b>. Este macaco consegue pular de <b>3 em 3</b> troncos. <b>Clique</b> nos troncos que ele deverá pular para chegar até a <b>bananeira</b></p>'
];

export const level2SelectedMonkey1 = [
    'Parece que os macacos conseguiram encontrar mais <b>bananas</b>! Agora que você escolheu o <b>macaco filhote</b>, clique nos <b>troncos</b> que ele deverá <b>pular</b> para chegar até a <b>bananeira</b>. Lembre que este macaco só consegue pular de <b>2 em 2</b> troncos.'
];

export const level2SelectedMonkey2 = [
    'Parece que os macacos conseguiram encontrar mais <b>bananas</b>! Agora que você escolheu o <b>macaco adulto</b>, clique nos <b>troncos</b> que ele deverá <b>pular</b> para chegar até a <b>bananeira</b>. Lembre que este macaco só consegue pular de <b>3 em 3</b> troncos.'
];

export const question1 = `
    <div class='container-fluid'>
        <div class='row'>
            <div class='col-xs-7'>
                <p class='subtitle'>Apenas para ver se entrou aqui mesmo</p>
                <p class='subtitle'><input id='answer' type='number' min='0'></p>
                <p class='subtitle'><input id='answer' type='number' min='0'></p>
                <p class='subtitle'><input id='answer' type='number' min='0'></p>
            </div>
        </div>
    </div>
`


// WEBPACK FOOTER //
// ./src/app/pages/stage-three/stage-three.const.js